/**
 * MenuItemTextContainer component.
 */
import Fonts from '@shared/assets/style/default/fonts';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Props for the menu item text container.
 */
interface Props {
  collapse: boolean;
  focused: boolean;
}

/**
 * Styled container for the menu item text.
 */
const MenuItemTextContainer = styled.div<Props>`
  display: inline-block;
  font-family: ${Fonts['regular']};
  max-width: ${({ collapse }) => (collapse ? 0 : 268 * Screen.widthRatio)}px;
  padding-left: ${({ collapse }) => (collapse ? 0 : 4) * Screen.widthRatio}px;
  padding-right: ${({ collapse }) => (collapse ? 0 : 4) * Screen.widthRatio}px;
  overflow: hidden;
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.8);
  white-space: nowrap;
`;

export default withOpacity(MenuItemTextContainer);
